module.exports = __webpack_public_path__ + "img/DO.8ed31aa5.png";